import React from 'react';
import { ApiContext } from '../context.js';
import PropTypes from 'prop-types';
export default function TablistContainer(deps, props) {
  var _deps = deps(React.useContext(ApiContext)),
    tablistContainerPropsManager = _deps.tablistContainerPropsManager;
  return /*#__PURE__*/React.createElement("div", tablistContainerPropsManager(), props.children);
}